module.exports = __webpack_public_path__ + "static/media/HamburgerLoyaltyBalanceScreen.01802f2f.png";